import React, { useCallback, useEffect, useState } from 'react';
import '../toolbar/toolbar.css';
import './notifications.css';
import Tooltip from '../../lib/tooltip/Tooltip';
import notifications, { Notification } from '../../services/notifications';
import Badge from '../../lib/badge/Badge';
import { useParams } from 'react-router-dom';

export interface INotificationsIconButtonProps {
	onClick: (e: any) => void;
}

const NotificationsIconButton: React.FC<INotificationsIconButtonProps> = ({
	onClick
}) => {
	const { id: projectId } = useParams<{ id: string }>();
	const channel = notifications.getChannel('project--' + projectId);

	const resolveBadges = () => {
		return {
			errors: channel.getUnseenErrorsCount(),
			warnings: channel.getUnseenWarningsCount(),
			infos: channel.getUnseenInfosCount(),
			success: channel.getUnseenSuccessCount()
		};
	};

	const [badges, setBadges] = useState(resolveBadges);

	const handleNotificationsUpdate = useCallback(
		(_: Notification) => {
			setBadges(resolveBadges());
		},
		[projectId]
	);

	useEffect(() => {
		channel.on('new', handleNotificationsUpdate);
		channel.on('clear', handleNotificationsUpdate);
		channel.on('remove', handleNotificationsUpdate);
		return () => {
			channel.off('new', handleNotificationsUpdate);
			channel.off('clear', handleNotificationsUpdate);
			channel.off('remove', handleNotificationsUpdate);
		};
	}, [projectId]);

	const unseenCount = channel.getUnseenCount();

	const badgesList = [];
	if (badges.errors > 0)
		badgesList.push({
			type: 'error',
			value: badges.errors,
			color: 'error'
		});
	if (badges.warnings > 0)
		badgesList.push({
			type: 'warning',
			value: badges.warnings,
			color: 'warning'
		});
	if (badges.infos > 0)
		badgesList.push({
			type: 'info',
			value: badges.infos,
			color: 'primary'
		});
	if (badges.success > 0)
		badgesList.push({
			type: 'success',
			value: badges.success,
			color: 'success'
		});

	return (
		<span>
			<button
				className="toolbar__button"
				id="notifications-toolbar-button"
				onClick={onClick}
			>
				<i className="fa-solid fa-bell" />
				<div
					style={{
						position: 'absolute',
						top: -2,
						right: 6,
						display: 'flex',
						flexDirection: 'row'
					}}
				>
					{badgesList.map((b, i) => (
						<Badge
							key={b.type}
							color={b.color as any}
							style={{
								// @ts-ignore
								marginLeft: i > 0 ? -4 : 0,
								boxShadow:
									i > 0
										? '-1px 0px 2px rgba(0,0,0,0.1)'
										: 'none'
							}}
						>
							{b.value > 100 ? '+100' : b.value}
						</Badge>
					))}
				</div>
				<p>Inbox</p>
			</button>
			<Tooltip
				anchorQuerySelector="#notifications-toolbar-button"
				placement="left"
			>
				{unseenCount > 0
					? `${unseenCount} new notifications that require your attention`
					: `Here you can see all new and past notifications that require your attention`}
			</Tooltip>
		</span>
	);
};

export default NotificationsIconButton;
